export const guardLinkStore = {
    openUrl: null,

    openGuard: (url) => {
        if (!url) return
        guardLinkStore.openUrl = url
        window.dispatchEvent(
            new CustomEvent('ve-open-popup', {
                detail: { popupId: 'external-guard' },
            })
        )
    },

    confirm: () => {
        if (guardLinkStore.openUrl) {
            window.open(guardLinkStore.openUrl, '_blank')
        }
        guardLinkStore.openUrl = null
        window.dispatchEvent(
            new CustomEvent('ve-close-popup', {
                detail: { popupId: 'external-guard' },
            })
        )
    },

    cancel: () => {
        guardLinkStore.openUrl = null
        window.dispatchEvent(
            new CustomEvent('ve-close-popup', {
                detail: { popupId: 'external-guard' },
            })
        )
    },
}
